export enum ETipoVinculo {
    Parceiro = 1,
    Usuario = 2,
    Cadastro = 3,
    Chamado = 4,
    Ocorrencia = 5,
}
